import { useLang } from "@/lib/i18n";

export const MosqueFilter = ({ mosques, value, onChange }) => {
  const { t } = useLang();
  if (!mosques || mosques.length < 2) return null;
  const chip = (active) =>
    `flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs transition-colors active:scale-95 ${
      active ? "bg-foreground text-background border-foreground font-medium" : "border-border text-muted-foreground hover:text-foreground"
    }`;
  return (
    <div className="flex flex-wrap gap-2" data-testid="mosque-filter">
      <button data-testid="mosque-chip-all" className={chip(value === "all")} onClick={() => onChange("all")}>
        {t("all_mosques")}
      </button>
      {mosques.map((m) => (
        <button key={m.id} data-testid={`mosque-chip-${m.id}`} className={chip(value === m.id)} onClick={() => onChange(m.id)}>
          <span className="h-2 w-2 rounded-full shrink-0" style={{ background: m.color || "#2563EB" }} />
          {m.name}
        </button>
      ))}
    </div>
  );
};
